// Chip "N en curso" (DN1 del diccionario de métricas v1): los paros ABIERTOS
// no suman minutos ni eventos a ningún KPI; se informan aparte. Mismo patrón
// visual que el KPI de paros del C1 del coordinador.

export function ParosEnCursoChip({ cantidad }: { cantidad: number }) {
  if (cantidad <= 0) return null;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-dashed border-warn px-2 py-px text-[10.5px] font-semibold text-warn"
      title="Paros abiertos en este momento. No suman minutos ni eventos hasta que se cierren; por eso se informan aparte."
    >
      <span className="size-1.5 animate-pulse rounded-full bg-warn" />
      {cantidad} en curso — aparte, {cantidad === 1 ? 'no suma' : 'no suman'}
    </span>
  );
}
